module.exports = __webpack_public_path__ + "img/cardFixed.40d3925d.png";